import { createRouter, createWebHashHistory } from 'vue-router'
import Landing from '../views/Landing.vue'
import OrderMenu from '../views/OrderMenu.vue'
import OrderDetail from '../views/OrderDetail.vue'
import OrderSuccess from '../views/OrderSuccess.vue'
import OrderHistory from '../views/OrderHistory.vue'
import OrderEmpty from '../views/OrderEmpty.vue'
import Offline from '../views/Offline.vue'
import OrderNotFound from '../views/OrderNotFound.vue'
import StaticPage from '../views/StaticPage.vue'
import BillDetail from '../views/BillDetail.vue'
import PageNotFound from '../views/PageNotFound.vue'
import PaymentResponse from '../views/PaymentResponse.vue'
import PaymentSuccess from '../views/PaymentSuccess.vue'
import PaymentFail from '../views/PaymentFail.vue'
import Review from '../views/Review.vue'
// import CryptoJs from '../views/CryptoJs.vue'

import { library } from "@fortawesome/fontawesome-svg-core";
import { faPhone } from "@fortawesome/free-solid-svg-icons";


library.add(faPhone);

const routes = [

  {
    path: '/:restaurant_id/:table_id',
    name: 'Landing',
    component: Landing
  },
  {
    path: '/offline/',
    name: 'Offline',
    component: Offline
  },
  {
    path: '/pagenotfound/',
    name: 'PageNotFound',
    component: PageNotFound
  },
  {
    path: '/menu/:restaurant_id/:table_id',
    name: 'OrderMenu',
    component: OrderMenu
  },
  {
    path: '/order_detail/:session_uuid',
    name: 'OrderDetail',
    component: OrderDetail
  },
  {
    path: '/bill_detail/:session_uuid',
    name: 'BillDetail',
    component: BillDetail
  },
  {
    path: '/order/success/:session_uuid',
    name: 'OrderSuccess',
    component: OrderSuccess
  },
  {
    path: '/order/history/:session_uuid',
    name: 'OrderHistory',
    component: OrderHistory
  },

  {
    path: '/order/empty/:session_uuid',
    name: 'OrderEmpty',
    component: OrderEmpty
  },
  {
    path: '/static:page_id',
    name:'StaticPage',
    component: StaticPage
  },
  {
    path: '/order_not_found/',
    name: 'OrderNotFound',
    component: OrderNotFound
  },
  {
    path: '/payment_response/:order_id/',
    name: 'PaymentResponse',
    component: PaymentResponse
  },
  {
    path: '/payment_cancel/:order_id/',
    name: 'PaymentFail',
    component: PaymentFail
  },

  {
    path: '/restaurant/payment_success/',
    name: 'PaymentSuccess',
    component: PaymentSuccess
  },
  {
    path: '/review/',
    name: 'Review',
    component: Review
  },
  {
    // path: "*",
    path: "/:pathMatch(.*)",
    name: "PageNotFound",
    component: PageNotFound,
},

  // {
  //   path: '/crypto',
  //   name: 'CryptoJs',
  //   component: CryptoJs
  // },

  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
